<div class="govuk-width-container">
    <main class="govuk-main-wrapper" id="main-content" tabindex="-1">
        <div class="govuk-grid-row">
            <ng-container *ngIf="!loading && !showB2c">
                <div class="govuk-grid-column-one-half center">
                    <h1 class="govuk-heading-xl">Account Login</h1>
                    <app-custom-object-banner page="access"></app-custom-object-banner>
                    <ng-container *ngIf="loginForm.controls">
                        <form [formGroup]="loginForm">
                            <fieldset class="govuk-fieldset">
                                <legend class="govuk-fieldset__legend govuk-fieldset__legend--l">
                                    <!-- <h2 class="govuk-fieldset__heading"> -->
                                    Sign in to view bookings and to manage your account.
                                    <!-- </h2> -->
                                </legend>

                                <div class="login-wrapper">
                                    <div class="govuk-form-group">
                                        <label class="govuk-label" for="email">
                                            Email
                                        </label>
                                        <input class="govuk-input" id="email" name="email" formControlName="email"
                                            type="email" autocomplete="address-line1" placeholder="Your Email">
                                    </div>


                                    <div class="govuk-form-group govuk-password-input"
                                        data-module="govuk-password-input" #password>

                                        <label class="govuk-label" for="password-input">
                                            Password
                                        </label>

                                        <div class="govuk-input__wrapper govuk-password-input__wrapper">
                                            <input
                                                class="govuk-input govuk-password-input__input govuk-js-password-input-input"
                                                id="password-input" formControlName="password" name="password"
                                                type="password" placeholder="Your Password" spellcheck="false"
                                                autocomplete="current-password" autocapitalize="none">
                                            <button type="button"
                                                class="govuk-button govuk-button--secondary govuk-password-input__toggle govuk-js-password-input-toggle"
                                                data-module="govuk-button" aria-controls="password-input"
                                                aria-label="Show password" hidden>
                                                Show
                                            </button>
                                        </div>

                                    </div>
                                    <div class="govuk-form-group" *ngIf="loginError">
                                        <p class="govuk-error-message"><span
                                                class="govuk-visually-hidden">Error:</span>{{
                                            loginErrorMessage }}</p>
                                    </div>
                                    <div class="govuk-form-group">
                                        <button (click)="submit()" type="submit"
                                            class="govuk-button govuk-button--primary" data-module="govuk-button"
                                            [disabled]="!loginForm.valid">
                                            Login
                                        </button>
                                    </div>

                                </div>
                            </fieldset>
                        </form>
                    </ng-container>
                    <ng-container *ngIf="resetPath.length > 0">
                        <div>
                            <p class="govuk-body">
                                <a href="#" class="app-link" (click)="toggleResetForm()">Forgot your password?</a>
                            </p>
                        </div>
                        <ng-container *ngIf="shouldShowPasswordReset">
                            <form [formGroup]="passwordResetForm">
                                <fieldset class="govuk-fieldset">
                                    <div class="govuk-form-group">
                                        <input class="govuk-input" id="reset-email-form" name="reset-email-form"
                                            type="text" autocomplete="email" placeholder="Enter email address"
                                            formControlName="email" tabindex="0" role="textbox">

                                        <div *ngIf="resetForm.email.errors">
                                            <p *ngIf="resetSubmitted && resetForm.email.errors.pattern" id="email-error"
                                                class="govuk-error-message">
                                                <span class="govuk-visually-hidden">Error:</span>
                                                {{'COMMON.FORMS.VALIDATION.EMAIL_INVALID'
                                                |
                                                translate}}
                                            </p>
                                            <p *ngIf="resetSubmitted && resetForm.email.errors.required"
                                                id="email-error" class="govuk-error-message">
                                                <span class="govuk-visually-hidden">Error:</span>
                                                {{'COMMON.FORMS.VALIDATION.EMAIL_REQUIRED'
                                                |
                                                translate}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="govuk-form-group">
                                        <button class="govuk-button" data-module="govuk-button"
                                            (click)="submitPasswordReset()">
                                            Send password reset
                                        </button>
                                        <ng-container *ngIf="resetSuccess">
                                            <span class="govuk-error-message forgot-password-success">If your email
                                                exists,
                                                you
                                                will receive a password reset email
                                                shortly</span>
                                        </ng-container>
                                        <ng-container *ngIf="resetError">
                                            <span class="govuk-error-message">There was a problem attempting to
                                                reset your
                                                password.</span>
                                        </ng-container>
                                    </div>
                                </fieldset>
                            </form>
                        </ng-container>
                    </ng-container>
                </div>
                <div *ngIf="!loading && !showB2c" class="govuk-grid-column-one-half img-wrapper">
                    <img src="westminster-login.jpg" alt="">
                </div>

            </ng-container>

        </div>

        <!-- b2c login -->
        <ng-container *ngIf="!loading && showB2c">
            <div class="govuk-grid-row">
                <div class="govuk-grid-column-full b2c">
                    <app-custom-object-banner page="access"></app-custom-object-banner>
                    <h1 class="govuk-heading-xl">Ceremony Login</h1>
                    <h2>Sign in to manage your ceremony.</h2>
                    <button *ngIf="!isLoggedInViaCookie" (click)="goToSSOLogin()" class="btn btn-primary">MyWestminster
                        Login</button>
                    <button *ngIf="isLoggedInViaCookie" (click)="goToSSOLogin()" class="btn btn-primary">
                        {{ 'COMMON.MY_ACCOUNT_BTN' | translate }}
                    </button>
                   
                </div>
                <div class="govuk-grid-column-full">
                    <img class="login-img" src="ceremonies-login-image.jpg" alt="bride and groom kissing, surrounded by friends and family." />
                </div>
            </div>
        </ng-container>
    </main>
</div>